<template>
  <v-container fluid>
          <v-card-title>
            <v-icon class="me-2">mdi-cube</v-icon>
            Products
          </v-card-title>
          <v-card-subtitle> Manage your products here. </v-card-subtitle>
          <v-card-actions>
            <v-btn @click="openProductDialog" color="primary">
              <v-icon left>mdi-plus</v-icon>
              Add Product
            </v-btn>
          </v-card-actions>
          <v-card-text>
            <!-- <v-select
                v-model="selectedFilterCategory"
                :items="categories"
                item-title="category"
                item-value="category_id"
                label="Select Category"
                @change="onCategoryChangeForFilter"
                solo
                clearable
                dense
            ></v-select> -->
            <v-row class="d-flex" style="width: 100%;">
                <v-col cols="12" sm="8" md="6" lg="5" class="d-flex justify-center">
                  <v-autocomplete
                    variant="outlined"
                    v-model="selectedCategoryFilter"
                    :items="categories"
                    label="Category"
                    item-title="category"
                    item-value="category_id"
                    density="compact"
                    clearable
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete
                    v-model="selectedSubcategoryFilter"
                    :items="subcategories"
                    label="Subcategory"
                    item-title="subcategory"
                    item-value="subcategory_id"
                    variant="outlined"
                    density="compact"
                    clearable
                    :disabled="!selectedCategory"
                  ></v-autocomplete>
                </v-col>
              </v-row>

           <!-- Product List -->
      <v-data-iterator
        :items="filteredProducts"
        :items-per-page="itemsPerPage"
        v-model:search="search"
        :loading="loading"
      >
        <!-- Header with Pagination -->
        <template v-slot:header="{ page, pageCount, prevPage, nextPage }">
          <div
            class="text-h4 font-weight-bold d-flex justify-space-between mb-4 align-center"
          >
            <v-text-field
              v-model="search"
              density="compact"
              label="Search"
              prepend-inner-icon="mdi-magnify"
              style="max-width: 300px"
              variant="outlined"
              clearable
              hide-details
              single-line
            ></v-text-field>
            <div class="d-flex align-center">
              <div class="d-inline-flex">
                <v-btn
                  :disabled="page == 1"
                  class="me-2"
                  icon="mdi-arrow-left"
                  size="small"
                  variant="tonal"
                  @click="prevPage"
                ></v-btn>
                <v-btn
                  :disabled="page == pageCount"
                  icon="mdi-arrow-right"
                  size="small"
                  variant="tonal"
                  @click="nextPage"
                ></v-btn>
              </div>
            </div>
          </div>
        </template>

        <!-- Product Cards -->
        <template v-slot:default="{ items }">
          <v-row v-if="items.length == 0" class="justify-center">
            <v-col class="text-center" cols="12">
              <v-alert type="info" border="left" icon="mdi-information">
                No Products Available
              </v-alert>
            </v-col>
          </v-row>
          <v-row else>
            <v-col
              v-for="(item, i) in items"
              :key="i"
              cols="12"
              sm="3"
              xl="3"
            >
              <v-card>
                <v-chip-group>
                  <v-chip class="ma-1" color="primary" label>
                    {{ getCategoryName(item.raw.subcategory_id) }}
                  </v-chip>
                  <v-chip class="ma-1" color="secondary" label>
                    {{ getSubcategoryName(item.raw.subcategory_id) }}
                  </v-chip>
                </v-chip-group>
                <!-- <v-img
                  :src="getImageUrl(item.raw.medias[0]?.media?.media_name)"
                  height="150"
                  contain
                ></v-img> -->
                <v-img
                  :src="getImageUrl(getSortedImages(item.raw)[0]?.media_name)"
                  height="150"
                  contain
                ></v-img>
                <v-card-title>{{ item.raw.product_name }}</v-card-title>
                <!-- <v-card-subtitle
                  >Rp {{ numeralFormat(item.raw.price, "0,[]00") }}</v-card-subtitle
                > -->
                <v-card-subtitle class="font-weight-medium text-primary">
                  {{ getDisplayPrice(item.raw) }}
                </v-card-subtitle>

                <!-- Action Buttons -->
                <v-card-actions>
                  <v-btn
                    @click="viewProduct(item.raw)"
                    color="primary"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-eye"
                  >
                    View
                  </v-btn>
                  <v-btn
                    @click="editProduct(item.raw)"
                    color="secondary"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-pencil"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    @click="confirmDeleteProduct(item.raw.product_id)"
                    color="red"
                    variant="flat"
                    size="small"
                    prepend-icon="mdi-delete"
                  >
                    Delete
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
          </v-card-text>

    <!-- Product Dialog-->
    <v-dialog v-model="productDialog" max-width="800px" persistent scrollable>
    <v-card>
      <!-- Toolbar -->
      <v-toolbar>
        <v-toolbar-title>
          <strong>{{ editMode ? "Edit Produk" : "Tambah Produk" }}</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog('product')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form @submit.prevent="submitProduct">
          <!-- Product Details -->
          <v-text-field v-model="product.item_code" label="Kode Item" variant="outlined" density="compact"></v-text-field>
          <v-text-field v-model="product.name" label="Nama Produk" required variant="outlined" density="compact"></v-text-field>
          <!-- <v-text-field 
            v-model="product.price" 
            label="Harga" 
            required 
            prefix="Rp" 
            variant="outlined" 
            density="compact"
            :readonly="product.variations && product.variations.length > 0"
            persistent-hint
          ></v-text-field> -->
          <v-text-field 
            v-if="!product.variations || product.variations.length === 0"
            v-model="product.price" 
            label="Harga" 
            required 
            prefix="Rp" 
            variant="outlined" 
            density="compact"
          ></v-text-field>
          <v-text-field 
            v-model="product.product_qty" 
            label="Stok" 
            type="number" 
            required 
            variant="outlined" 
            density="compact"
            :readonly="product.variations && product.variations.length > 0"
            persistent-hint
          ></v-text-field>
          <v-text-field v-model="product.weight" label="Berat Produk" type="number" suffix="gram" required variant="outlined" density="compact"></v-text-field>
          <v-textarea v-model="product.description" label="Deskripsi" variant="outlined" density="compact"></v-textarea>
          <v-textarea v-model="product.specification" label="Spesifikasi" variant="outlined" density="compact"></v-textarea>
          <v-text-field v-model="product.google_drive_link" label="Link Video (Pastikan file sudah di public)" placeholder="https://drive.google.com/file/d/FILE_ID/view?usp=sharing" required variant="outlined" density="compact"></v-text-field>
          <v-card v-if="product.google_drive_link" class="mt-2 mb-3" outlined>
            <v-card-title class="text-subtitle-2">Preview Video</v-card-title>
            <v-card-text>
              <div class="video-wrapper">
                <iframe
                  :src="`https://drive.google.com/file/d/${extractDriveFileId(product.google_drive_link)}/preview`"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                  loading="lazy"
                  frameborder="0"
                  width="100%" height="100%"
                ></iframe>
              </div>
            </v-card-text>
          </v-card>

          <v-text-field
            v-model="product.shopee_link"
            label="Link Shopee"
            placeholder="https://shopee.co.id/..."
            variant="outlined"
            density="compact"
          ></v-text-field>

          <!-- Category and Subcategory -->
          <v-autocomplete
            v-model="selectedCategory"
            variant="outlined"
            :items="categories"
            item-value="category_id"
            item-title="category"
            label="Kategori"
            density="compact"
            @update:model-value="onCategoryChange"
            required
          ></v-autocomplete>
          <v-autocomplete
            v-model="product.subcategory_id"
            variant="outlined"
            :items="filteredSubcategories"
            item-value="subcategory_id"
            item-title="subcategory"
            label="Subkategori"
            density="compact"
            :disabled="!selectedCategory"
            required
          ></v-autocomplete>

          <!-- Image Upload -->
          <v-file-input
            v-model="product.images"
            variant="outlined"
            label="Images"
            accept="image/*"
            multiple
            @change="handleImageChange"
          ></v-file-input>

          <!-- Image Preview -->
          <div v-if="imagePreviews.length && this.editMode == false">
            <v-row>
              <v-col v-for="(image, index) in imagePreviews" :key="index" cols="12" sm="6" md="4">
                <v-img :src="image" contain max-height="200px"></v-img>
                <v-btn @click="removeExistingImage(index)" color="error" size="x-small" class="mt-2">
                  <v-icon left>mdi-delete</v-icon>
                  Remove Image
                </v-btn>
              </v-col>
            </v-row>
          </div> 
          <!-- Draggable Image Preview -->
          <div v-if="imagePreviews.length && this.editMode == true">
          <draggable v-model="product.images" @end="onImageOrderChange" item-key="media_id">
            <template #item="{ element, index }">
              <v-col cols="12" sm="6" md="4">
                <v-img :src="getImageUrl(element.media_name)" contain max-height="200px"></v-img>
                <v-btn @click="removeExistingImage(index)" color="error" size="x-small" class="mt-2">
                  <v-icon left>mdi-delete</v-icon>
                  Remove Image
                </v-btn>
              </v-col>
            </template>
          </draggable>
          </div>
          <!-- Variations Section -->
          <h4 class="mt-5 mb-2">Variasi Produk</h4>
          <v-divider></v-divider>

          <v-row v-for="(variation, index) in product.variations" :key="index" class="mb-3" dense>
            <v-col cols="12" sm="6">
              <v-text-field v-model="variation.item_code" label="Kode Item"  variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="variation.variation_name" label="Variation Name"  variant="outlined" density="compact"></v-text-field>
            </v-col>
            
            <v-col cols="12" sm="6">
              <v-text-field v-model="variation.variation_price" label="Variation Price" type="number" variant="outlined" density="compact"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="variation.variation_qty" label="Variation Quantity" type="number" variant="outlined" density="compact"></v-text-field>
            </v-col>
            
            <!-- Remove Variation Button -->
            <v-col cols="12">
              <v-btn color="error" @click="removeVariation(index)" size="x-small">
                <v-icon left>mdi-delete</v-icon>
                Remove Variation
              </v-btn>
            </v-col>
          </v-row>

          <!-- Add Variation Button -->
          <v-btn class="mt-3" color="primary" outlined @click="addVariation">Tambah Variasi</v-btn>

          <!-- Actions -->
          <v-card-actions class="justify-end">
            <v-btn prepend-icon="mdi-check-circle" type="submit" variant="flat" color="primary">Save</v-btn>
            <v-btn prepend-icon="mdi-close-circle" @click="closeDialog('product')" variant="flat" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>

    <!-- Confirmation Dialog for Image Deletion -->
    <v-dialog v-model="imageDeleteDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h5">Delete Image</v-card-title>
        <v-card-text> Apakah Anda yakin ingin menghapus gambar ini? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="flat" color="primary" text @click="imageDeleteDialog = false" prepend-icon="mdi-close">
            Cancel
          </v-btn>
          <v-btn variant="flat" color="error" text @click="confirmImageDelete" prepend-icon="mdi-delete">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>

<!-- Product Detail Dialog -->
<!-- Product Detail Dialog -->
<v-dialog v-model="productDetailDialog" max-width="1200px">
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <div class="text-h5 text-medium-emphasis ps-2">
        {{ selectedProduct.product_name }}
      </div>
      <v-btn icon="mdi-close" variant="text" @click="productDetailDialog = false"></v-btn>
    </v-card-title>

    <v-divider class="mb-4"></v-divider>

    <v-row no-gutters>
      <!-- LEFT: Images & Video -->
      <v-col cols="12" md="6" class="d-flex flex-column">
        <v-carousel
          v-if="sortedMedias.length"
          hide-delimiters
          delimiter-icon="mdi-square"
          show-arrows="hover"
          cycle
          height="auto"
        >
          <v-carousel-item
            v-for="(media, index) in sortedMedias"
            :key="index"
            :src="getImageUrl(media)"
            height="100%"
            width="100%"
          />
        </v-carousel>

        <v-img
          v-else
          :src="getMainImageUrl(selectedProduct.medias)"
          height="auto"
          width="100%"
          contain
        />

        <!-- VIDEO PRODUK (Google Drive) -->
        <v-card v-if="driveFileIdDetail" class="mt-4" outlined>
          <v-card-title class="text-subtitle-1 font-weight-bold">
            <v-icon class="me-2" size="18">mdi-play-circle</v-icon>
            Video Produk
          </v-card-title>
          <v-card-text>
            <div class="video-wrapper">
              <iframe
                :src="driveEmbedUrlDetail"
                allow="autoplay; fullscreen"
                allowfullscreen
                loading="lazy"
                frameborder="0"
                width="100%"
                height="100%"
              ></iframe>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- RIGHT: Details -->
      <v-col cols="12" md="6" class="pa-4">
        <v-chip v-if="selectedProduct.item_code" class="ma-1" color="primary" label>
          {{ selectedProduct.item_code }}
        </v-chip>

        <v-card-title class="text-h5 product-name-wrap">
          {{ selectedProduct.product_name }}
        </v-card-title>

        <v-card-subtitle class="text-h5">
          Rp {{ numeralFormat(selectedProduct.price, "0,[]00") }}
        </v-card-subtitle>

        <v-divider class="my-3"></v-divider>

        <h4 class="mb-2 font-semibold">Deskripsi</h4>
        <div class="relative">
          <p class="text-body-2 text-grey-darken-1" style="white-space: pre-line;">
            {{ selectedProduct.description || '-' }}
          </p>
        </div>

        <h4 class="mt-4 mb-2 font-semibold">Spesifikasi</h4>
        <div class="relative">
          <p class="text-body-2 text-grey-darken-1" style="white-space: pre-line;">
            {{ selectedProduct.specification || 'Tidak ada spesifikasi.' }}
          </p>
        </div>

        <v-row dense class="mt-4">
          <v-col cols="6">
            <v-card class="pa-3 text-center" outlined>
              <div class="text-caption text-grey">Stok</div>
              <div class="text-subtitle-1 font-weight-bold">
                {{ selectedProduct.product_qty }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card class="pa-3 text-center" outlined>
              <div class="text-caption text-grey">Berat</div>
              <div class="text-subtitle-1 font-weight-bold">
                {{ selectedProduct.product_weight }} gr
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <h4 class="mb-2 font-semibold" v-if="selectedProduct.variations?.length">Variasi Produk</h4>
        <v-row dense v-if="selectedProduct.variations?.length">
          <v-col
            v-for="variation in selectedProduct.variations"
            :key="variation.variation_id || variation.item_code || variation.variation_name"
            cols="12" sm="6" md="6"
          >
            <v-card class="pa-3" outlined>
              <div class="d-flex flex-column">
                <span class="text-subtitle-1 font-weight-bold">
                  {{ variation.variation_name }}
                </span>
                <span class="text-body-2 text-grey">
                  Kode: {{ variation.item_code || '-' }}
                </span>
                <span class="text-body-1 mt-1">
                  Rp {{ numeralFormat(variation.variation_price, "0,0") }}
                </span>
                <span class="text-caption mt-1">
                  Stok: {{ variation.variation_qty }}
                </span>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</v-dialog>




<!-- Delete Confirmation Dialog for Product -->
<v-dialog v-model="productDeleteDialog" max-width="400px">
  <v-card>
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>Are you sure you want to delete this product?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-close" 
        @click="productDeleteDialog = false"
      >
        Cancel
      </v-btn>
      <v-btn 
        color="error" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-delete" 
        @click="confirmDelete"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import { useDisplay } from 'vuetify'
import numeral from 'numeral'
import draggable from "vuedraggable"

export default {
  components: { draggable },
  data() {
    return {
      tab: "product",
      products: [], 
      categories: [],
      subcategories: [],
      filteredSubcategories: [],
      imagePreviews: [],
      selectedCategory: '',
      selectedCategoryFilter: '',
      selectedSubcategoryFilter: '',
      itemsPerPage: 12,
      productDialog: false,
      editMode: false,
      deleteDialog: false,
      productDetailDialog: false,
      selectedFilterCategory: '',
      selectedCategory: '',
      selectedSubcategory: '',
      selectedFilterSubcategory: '',
      selectedFilterCategory: '',
      search: '',
      product: {
        name: '',
        price: '',
        weight: '', // Add weight
        product_qty: '',
        description: '',
        specification: '',
        images: '',
        subcategory_id: '',
        item_code: '',
        variations: [],
        google_drive_link: '',
        shopee_link: ''
      },
      selectedProduct: {
        name: '',
        price: '',
        product_weight: '', // Add weight
        product_qty: '',
        description: '',
        specification: '',
        images: '',
        subcategory_id: '',
        item_code: '',
        variations: [],
        google_drive_link: '',
        shopee_link: ''
      },
      category: {
        category: '',
      },
      subcategory: {
        subcategory: '',
        category_id: '',
      },
      snackbar: {
        visible: false,
        message: '',
        timeout: 5000,
      },
      loading: true,
      imagePreviews: [], 
      newImagePreviews: [], 
      existingImages: [], 
      newImages: [],
      imageDeleteDialog: false,
      imageToRemoveIndex: '',
      productDeleteDialog: false
    };
  },
  async created() {
    await this.fetchProducts();
    await this.fetchCategories();
    await this.fetchSubcategories();
  },
  setup() {
    const { smAndDown } = useDisplay();
    return {
      isSmallScreen: smAndDown.value,
      
    };
    
  },
  watch: {
    // Memantau perubahan pada array variations secara mendalam (deep)
    'product.variations': {
      handler(newVariations) {
        // Jika ada variasi, hitung totalnya
        if (newVariations && newVariations.length > 0) {
          const totalQty = newVariations.reduce((sum, variation) => {
            // Gunakan parseInt untuk memastikan nilainya angka, default ke 0 jika kosong
            return sum + (parseInt(variation.variation_qty) || 0);
          }, 0);
          
          // Update stok utama dengan hasil penjumlahan
          this.product.product_qty = totalQty

          const validPrices = newVariations
            .map(v => parseFloat(v.variation_price))
            .filter(price => !isNaN(price) && price > 0) // Abaikan yang kosong atau bukan angka

          if (validPrices.length > 0) {
            // Ambil harga paling kecil (minimum)
            const minPrice = Math.min(...validPrices)
            this.product.price = minPrice
         }
        }
      },
      deep: true // Sangat penting: agar Vue mendeteksi perubahan nilai di BENTUK DALAM array/object
    }
  },
  computed: {
  filteredProducts() {
    // return this.filterProductsByCategory();
    return this.products.filter((product) => {
        let matchesCategory = this.selectedCategoryFilter
          ? product.subcategory.category_id == this.selectedCategoryFilter
          : true;
        let matchesSubcategory = this.selectedSubcategoryFilter
          ? product.subcategory.subcategory_id == this.selectedSubcategoryFilter
          : true;
        return matchesCategory && matchesSubcategory;
      });
  },
  sortedMedias() {
    return this.selectedProduct.medias.sort((a, b) => a.display_order - b.display_order);
  },
  driveFileIdDetail() {
    const link = this.selectedProduct?.google_drive_link;
    if (!link) return null;
    return this.extractDriveFileId(link);
  },
  driveEmbedUrlDetail() {
    return this.driveFileIdDetail
      ? `https://drive.google.com/file/d/${this.driveFileIdDetail}/preview`
      : null;
  },
},
  methods: {
    extractDriveFileId(url) {
    if (!url) return null;
    const patterns = [
      /\/file\/d\/([a-zA-Z0-9_-]{10,})/i,
      /[?&]id=([a-zA-Z0-9_-]{10,})/i,
      /\/uc\?id=([a-zA-Z0-9_-]{10,})/i,
    ];
    for (const re of patterns) {
      const m = url.match(re);
      if (m && m[1]) return m[1];
    }
    return null;
  },
    getSortedImages(product) {
    return product.medias
      .map(mediaItem => ({
        media_name: mediaItem.media ? mediaItem.media.media_name : '',
        display_order: mediaItem.display_order || 0, // Default to 0 if not present
      }))
      .sort((a, b) => a.display_order - b.display_order); // Sort by display_order
  },
    async fetchProducts() {
      try {
        const response = await this.$axios.get("/product", {
          params: {
            page: this.page,
            per_page: this.itemsPerPage,
          },
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });
        this.products = response.data.data;
        this.loading = false;
        this.pageCount = response.data.meta
          ? response.data.meta.total_pages
          : 0; 
      } catch (error) {
      }
    },
    async fetchCategories() {
      try {
        const response = await this.$axios.get("/category", {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });
        this.categories = response.data.data; // Access nested data
      } catch (error) {

      }
    },
    async fetchSubcategories() {
      try {
        const response = await this.$axios.get("/subcategory", {
          headers: {
            "Authorization": "Bearer " + localStorage.getItem('token'),
          },
        });
        this.subcategories = response.data.data;
      } catch (error) {
        // this.showSnackbar("Error fetching subcategories.", "error");
      }
    },
    addVariation() {
      this.product.variations.push({
        variation_name: '',
        variation_price: '',
        variation_qty: '',
        item_code:'',
        deleted: false, // Frontend only flag
      });
    },
//     removeVariation(index) {
//   // Mark the variation as deleted
//   this.product.variations[index].deleted = true;
  
//   const variation = this.product.variations[index];
//   const formData = new FormData();
//   if (variation.deleted) {
//     formData.append(`variations[${index}][deleted]`, 1);  // Mark for deletion
//     formData.append(`variations[${index}][variation_id]`, variation.variation_id || '');  // Ensure variation_id is present
//     formData.append(`variations[${index}][variation_name]`, variation.variation_name);
//     formData.append(`variations[${index}][item_code]`, variation.item_code);
//     formData.append(`variations[${index}][variation_price]`, variation.variation_price);
//     formData.append(`variations[${index}][variation_qty]`, variation.variation_qty);
//   }
// },
removeVariation(index) {
  const variation = this.product.variations[index];

  if (this.editMode && variation.variation_id) {
    // Only call the backend if in edit mode and variation has an ID
    this.$axios
      .delete(`/product/${this.product.id}/variation/${variation.variation_id}`, {
        headers: {
          "Authorization": "Bearer " + localStorage.getItem('token'),
        },
      })
      .then(() => {
        this.product.variations.splice(index, 1); // Remove from array after successful deletion
        this.showSnackbar("Variation removed successfully.", "success");
      })
      .catch(() => {
        this.showSnackbar("Failed to remove variation.", "error");
      });
  } else {
    // If not in edit mode or the variation has no ID, just remove it locally
    this.product.variations.splice(index, 1);
  }
},
    getCategoryName(subcategoryId) {
      const subcategory = this.subcategories.find(
        (sub) => sub.subcategory_id == subcategoryId
      );
      const category = this.categories.find(
        (cat) => cat.category_id == subcategory?.category_id
      );
      return category ? category.category : "Unknown";
    },
  // Fetch the category_id from the subcategory
  getCategoryId(subcategoryId) {
    const subcategory = this.subcategories.find(
      (sub) => sub.subcategory_id == subcategoryId
    );
    return subcategory ? subcategory.category_id : '';
  },

  // Filter products based on selected category
  filterProductsByCategory() {
    // If no category is selected, show all products
    if (!this.selectedFilterCategory) {
      return this.products;
    }

    // Filter the products by matching category_id
    return this.products.filter((product) => {
      const productCategoryId = this.getCategoryId(product.subcategory_id);
      return productCategoryId == this.selectedFilterCategory;
    });
  },

  // Handle category change
  onCategoryChangeForFilter() {
    // This method is triggered when the filter changes
  },
    getSubcategoryName(subcategoryId) {
      const subcategory = this.subcategories.find(
        (sub) => sub.subcategory_id == subcategoryId
      );
      return subcategory ? subcategory.subcategory : "Unknown";
    },
    // getImageUrl(mediaName) {
    //   return `${this.$urlImage}storage/images/${mediaName}`;
    // },
    getImageUrl(image) {
      // If it's a base64 string (preview)
      if (typeof image == 'string' && image.startsWith('data:image')) {
        return image;
      }
      // If it's a file object (actual image to be uploaded)
      if (image && image.name) {
        return URL.createObjectURL(image); // Temporary URL for new file
      }
      // Default URL for existing images
      return `${this.$urlImage}storage/images/${image}`;
    },
    onCategoryChange() {
      // this.selectedCategory = categoryId;
      this.filteredSubcategories = this.subcategories.filter(
      (sub) => sub.category_id == this.selectedCategory
    );

      this.product.subcategory_id = '';
    },
    openProductDialog() {
      this.editMode = false;
      this.product = {
        name: '',
        price: '',
        weight: '',
        product_qty: '',
        description: '',
        images: [],
        subcategory_id: '',
        category_id: '',
        item_code: '',
        variations: [],
        google_drive_link:'',
        shopee_link: ''
      };
      this.productDialog = true;
    },
    resetProductForm() {
      this.product = {
        name: '',
        price: '',
        weight: '',
        product_qty: '',
        description: '',
        specification: '',
        images: '',
        category_id: '',
        subcategory_id: '',
        item_code: '',
        category_id: '',
        variations: [],
        google_drive_link: '',
        shopee_link: ''
        
      };
      this.imagePreviews = [];
      this.existingImages = [];
    },
    closeDialog(dialogType) {
      if (dialogType == 'product') {
        this.resetProductForm();
        this.productDialog = false;
      } 
    },


//   // Show the product dialog
//   this.productDialog = true;
onImageOrderChange() {
  this.product.images = this.product.images.map((image, index) => {
    if (typeof image == 'object' && image !== '') {
      // Update the display order for existing objects
      image.display_order = index + 1;
      return image;
    } else if (typeof image == 'string') {
      // Handle string-based images (e.g., new ones or improperly loaded images)
      return {
        media_name: image,
        media_id: '', // New images don't have a media_id
        display_order: index + 1,
      };
    } else {
      return image; // Keep original if unknown format
    }
  });

  // Update image previews
  this.imagePreviews = [
    ...this.product.images.map((image) =>
      this.getImageUrl(image.media_name || image)
    ),
    ...this.newImages.map((newImage) => URL.createObjectURL(newImage)),
  ];

},
getDisplayPrice(product) {
      // 1. Cek apakah produk memiliki variasi
      if (product.variations && product.variations.length > 0) {
        // Ambil semua harga variasi yang valid (angka dan lebih dari 0)
        const prices = product.variations
          .map(v => parseFloat(v.variation_price))
          .filter(p => !isNaN(p) && p > 0);

        if (prices.length > 0) {
          // Cari harga termurah dan termahal
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);

          // Jika harga semua variasi sama, tampilkan 1 harga saja
          if (minPrice === maxPrice) {
            return `Rp ${this.numeralFormat(minPrice, "0,0")}`;
          }
          
          // Jika harganya berbeda-beda, tampilkan format "Rp Min - Rp Max"
          return `Rp ${this.numeralFormat(minPrice, "0,0")} - Rp ${this.numeralFormat(maxPrice, "0,0")}`;
        }
      }

      // 2. Fallback: Jika tidak ada variasi, kembalikan harga utama (base price)
      return `Rp ${this.numeralFormat(product.price, "0,0")}`;
    },


editProduct(item) {
  this.editMode = true;
  this.currentProduct = item.product_id;

  // Filter subcategories by the selected category
  const subcategory = this.subcategories.find(
    (sub) => sub.subcategory_id == item.subcategory_id
  );

  if (subcategory) {
    this.selectedCategory = parseInt(subcategory.category_id)
    this.filteredSubcategories = this.subcategories.filter(
      (sub) => sub.category_id == this.selectedCategory
    );
  }

  console.log('disini', typeof this.selectedCategory)

  // Construct existing images with media_id, media_name, and display_order
  // Update display_order based on actual item order
  this.existingImages = item.medias
  .map((mediaItem, index) => ({
    media_id: mediaItem.media ? mediaItem.media.media_id : '',
    media_name: mediaItem.media ? mediaItem.media.media_name : '',
    media_url: mediaItem.media
      ? this.getImageUrl(mediaItem.media.media_name)
      : '',
    display_order: mediaItem.display_order || index + 1, // Use display_order from backend, fallback to index
  }))
  .sort((a, b) => a.display_order - b.display_order);

  // Initialize new images as an empty array
  this.newImages = [];

  // Combine existing images and new images for preview
  this.imagePreviews = [
    ...this.existingImages.map((image) => image.media_name),
    ...this.newImages.map((newImage) => URL.createObjectURL(newImage)), // Previews for new images
  ];

  // Initialize product object
  this.product = {
    id: item.product_id,
    name: item.product_name,
    price: item.price,
    weight: item.product_weight,
    product_qty: item.product_qty,
    description: item.description,
    item_code: item.item_code,
    specification: item.specification,
    category_id: parseInt(this.selectedCategory),
    subcategory_id: parseInt(item.subcategory_id),
    google_drive_link: item.google_drive_link || '', // NEW
    shopee_link: item.shopee_link || '',
    images: [...this.existingImages], // For existing images
    variations: item.variations || [], // Default to empty array if no variations

  };

  // Show the product dialog
  this.productDialog = true;
},




    viewProduct(product) {

  this.selectedProduct = {
    product_name: product.product_name,
    price: product.price,
    description: product.description,
    specification: product.specification,
    subcategory_id: product.subcategory_id,
    item_code: product.item_code,
    product_qty: product.product_qty,
    product_weight: product.product_weight,
    medias: product.medias.map(item => item.media.media_name) || [], 
    variations: product.variations || [],  // Make sure variations are added here
    has_variation: product.has_variation, // This helps in checking whether the product has variations
    google_drive_link: product.google_drive_link
  };

  this.productDetailDialog = true;
},
handleImageChange(event) {
  const files = event.target.files || event;

  // for (let i = 0; i < files.length; i++) {
  //   const imageUrl = URL.createObjectURL(files[i]); // Create an object URL for the image

  //   // Append new image preview to the imagePreviews array
  //   this.imagePreviews.push(imageUrl); // This should work in Vue 3

  //   // Append new image to `newImages` array (for upload)
  //   this.newImages.push(files[i]);
  // }

  if (files && files.length) {
        this.newImages = Array.from(files);

        // Generate image previews
        this.imagePreviews = this.newImages.map(file =>
          URL.createObjectURL(file)
        );
      }
},


      removeExistingImage(index) {
  // Store the index of the image to be deleted
  this.imageToRemoveIndex = index;
  this.imageDeleteDialog = true;
},

async confirmImageDelete() {
  try {
    // Get the media_id from the existingImages array
    const mediaId = this.existingImages[this.imageToRemoveIndex]?.media_id;
    const productId = this.currentProduct;  // Assuming `this.product.id` is the current product's ID

    if (!mediaId) {
      this.showSnackbar("Error: Could not find the media ID.", "error");
      return;
    }

    // Remove the media from the existingImages and imagePreviews arrays firs
    
    // Remove the media from the existingImages and imagePreviews arrays reactively
    this.existingImages = [
      ...this.existingImages.slice(0, this.imageToRemoveIndex),
      ...this.existingImages.slice(this.imageToRemoveIndex + 1)
    ];
    
    this.imagePreviews = [
      ...this.imagePreviews.slice(0, this.imageToRemoveIndex),
      ...this.imagePreviews.slice(this.imageToRemoveIndex + 1)
    ];


    // Call the API to delete the media (detaching it from the product and deleting the file)
    const response = await this.$axios.delete(`/product-media/${productId}/${mediaId}`, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem('token'),
      }
    });

    // After successful deletion from backend, fetch the updated products data
    this.fetchProducts();

    // Show success message
    this.showSnackbar("Image successfully deleted.", "success");
    
  } catch (error) {
    this.showSnackbar("Error deleting image: " + (error.response?.data?.message || "Something went wrong"), "error");
  } finally {
    // Close the image delete dialog and clear the index
    this.product.images = [...this.existingImages];
    this.imageDeleteDialog = false;
    this.imageToRemoveIndex = '';
  }
},

    removeNewImage(index) {
      this.newImagePreviews.splice(index, 1);
      this.newImages.splice(index, 1); // Make sure to also remove from newImages array
    },

async submitProduct() {
  const formData = new FormData();

  // Append basic product details
  formData.append("product_name", this.product.name);
  formData.append("item_code", this.product.item_code);
  formData.append("price", this.product.price);
  formData.append("product_qty", this.product.product_qty);
  formData.append("product_weight", this.product.weight);
  formData.append("description", this.product.description);
  formData.append("specification", this.product.specification);
  formData.append("subcategory_id", this.product.subcategory_id);
  formData.append("google_drive_link", this.product.google_drive_link.trim()); // NEW
  formData.append("shopee_link", (this.product.shopee_link || '').trim());

// jika kosong, biarkan tidak di-append -> backend tidak mengubah kolom saat update

  // Prepare media_ids with display_order for existing media
   // Filter only existing images for mediaIds
   const mediaIds = this.product.images
    .filter((image) => image.media_id)
    .map((image) => ({
      media_id: image.media_id,
      display_order: image.display_order,
    }));


  // Append media_ids array to the form data
  if (mediaIds.length > 0) {
  formData.append("media_ids", JSON.stringify(mediaIds));
}

  // Handle variations (including deletions and new variations)
  if (this.product.variations && this.product.variations.length > 0) {
    this.product.variations.forEach((variation, index) => {
      if (variation.deleted == undefined) {
        variation.deleted = 0; // Default to false if not provided
      }

      if (variation.deleted) {
        formData.append(`variations[${index}][deleted]`, 1);
      } else {
        if (variation.variation_id) {
          formData.append(`variations[${index}][variation_id]`, variation.variation_id);
        }
        formData.append(`variations[${index}][variation_name]`, variation.variation_name);
        formData.append(`variations[${index}][item_code]`, variation.item_code);
        formData.append(`variations[${index}][variation_price]`, variation.variation_price);
        formData.append(`variations[${index}][variation_qty]`, variation.variation_qty);
      }
    });
  }

  // Append new images from the newImages array
  if (this.newImages && this.newImages.length > 0) {
    this.newImages.forEach((image) => {
      formData.append("images[]", image); // Append each image file object
    });
  }

  try {
    this.showSnackbar("Please wait...");

    const url = this.editMode ? `/product/${this.product.id}` : "/product";
    const method = "POST"; // Always use POST for both create and update

    // Make the API call
    await this.$axios({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    });
    this.showSnackbar("Please wait ...")
    this.showSnackbar(
      this.editMode ? "Product updated successfully." : "Product created successfully."
    );

    await this.fetchProducts(); // Refresh the product list after saving
  } catch (error) {
    this.showSnackbar(
      "Error saving product: " +
        (error.response?.data?.message || "Something went wrong"),
      "error"
    );
  } finally {
    this.closeDialog("product");
  }
},






    async confirmDeleteProduct(productId){
      this.productIdToDelete = productId
      this.productDeleteDialog = true
    },
    async confirmDelete() {
      try {
        await this.$axios.delete(`/product/${this.productIdToDelete}`, {
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
        });
        this.productDeleteDialog = false
        this.showSnackbar("Delete product successful")
        this.fetchProducts()
        if (index !== -1) {
          this.products.splice(index, 1);
        }
      } catch (error) {
      }
    },
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
    numeralFormat(value, format) {
      return numeral(value).format(format) // Modify to use any numeral format as required
    },
  },


};
</script>

<style scoped>
.mx-auto {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust as needed */
}

.v-dialog__content--active {
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-dialog--fullscreen .v-card {
  height: 100%;
}

.expand-text {
  white-space: normal; /* Allows text to wrap */
  overflow: visible;  /* Ensures overflow is visible */
}

.video-wrapper{position:relative;width:100%;padding-top:56.25%;overflow:hidden;border-radius:12px}
.video-wrapper>iframe{position:absolute;inset:0;width:100%;height:100%}

.product-name-wrap {
  white-space: normal !important;     /* Boleh membungkus ke baris baru */
  overflow: visible !important;       /* Jangan sembunyikan kelebihan teks */
  text-overflow: clip !important;     /* Hilangkan efek "..." */
  word-break: break-word;             /* Pecah kata panjang jika perlu */
  line-height: 1.3;
}


</style>
